export default __webpack_public_path__ + "451d4e559d6f57cdf6a1c54a3e32e11d.woff";